<!--用户-->
<template>
  <div
    class="hbn-container"
    id="userInfo"
    v-loading="loading"
    element-loading-text="文件导出中..."
    element-loading-background="rgba(122, 122, 122, 0.8)"
  >
    <div class="hbn-container" id="userInfo">
      <div class="search-form">
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form
              ref="form"
              :model="form"
              label-width="80px"
              label-position="right"
              size="mini"
            >
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="名称">
                    <el-input
                      id="queryModelName"
                      v-model="PageQuery.queryModel.userName"
                      placeholder="名称"
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="昵称">
                    <el-input
                      id="queryModelNickName"
                      v-model="PageQuery.queryModel.nickName"
                      placeholder="昵称"
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="手机号">
                    <el-input
                      id="queryModelPhone"
                      v-model="PageQuery.queryModel.phone"
                      placeholder="手机号"
                      clearable
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24" v-show="show">
                <el-col :span="8">
                  <el-form-item label="状态">
                    <el-select
                      v-model="PageQuery.queryModel.state"
                      placeholder="请选择"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option label="待审核" value="0"></el-option>
                      <el-option label="启用" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="注册方式">
                    <el-select
                      v-model="PageQuery.queryModel.type"
                      placeholder="请选择"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option label="平台新增" value="0"></el-option>
                      <el-option label="小程序注册" value="1"></el-option>
                      <el-option label="平台导入" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位名称">
                    <el-input
                      id="queryModelunitName"
                      v-model="PageQuery.queryModel.unitName"
                      placeholder="单位名称"
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="岗位角色">
                    <el-input
                      id="queryModelstation"
                      v-model="PageQuery.queryModel.station"
                      placeholder="岗位角色"
                      clearable
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button size="mini" class="hbn-button-serach" @click="seach"
                >查找</el-button
              >
              <span class="control-collapse" @click="show = !show">{{
                show ? "收起" : "展开"
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="hbn-table-screen">
        <div class="operation">
          <el-button
            class="custom-button"
            type="primary"
            :icon="Search"
            @click="add"
          >
            <i class="el-icon-circle-plus-outline custom-icon"></i>
            <span>新增</span>
          </el-button>
          <el-button type="primary" class="custom-button" @click="importExcel">
            <i class="el-icon-upload custom-icon"></i>
            <span>导入</span>
          </el-button>
          <el-button type="primary" class="custom-button" @click="exportExcel">
            <i class="el-icon-download custom-icon"></i>
            <span>导出</span>
          </el-button>
        </div>

        <div class="custom-table-layer">
          <div style="margin-bottom: 13px">
            <vxe-table
              :data="DataList"
              round
              border
              height="388"
              class="mytable-scrollbar"
              style="width: 100%"
              :highlight-current-row="true"
              @current-change="handleCurrentChange"
              @checkbox-change="handleSelectionChange"
              ref="multipleTable"
              highlight-hover-row
              highlight-hover-column
              highlight-current-column
              show-overflow="tooltip"
              empty-text="没有更多数据了！"
              resizable
              stripe
            >
              <vxe-table-column
                fixed="left"
                type="checkbox"
                width="40"
              ></vxe-table-column>
              <vxe-table-column
                fixed="left"
                type="seq"
                width="55"
                title="序号"
                align="center"
              ></vxe-table-column>

              <template v-for="(item, key) in UserList" :key="key">
                <vxe-table-column
                  :field="item.prop"
                  :title="item.label"
                  :width="item.width"
                  align="center"
                  v-if="item.isShow"
                  show-overflow-tooltip
                  :sortable="item.order"
                  :class-name="JSON.stringify(item)"
                  :formatter="formatterData"
                />
              </template>

              <vxe-table-column
                width="350"
                fixed="right"
                title="操作"
                align="center"
              >
                <template #default="{ row, rowIndex }">
                  <el-button
                    type="text"
                    size="small"
                    @click="handleClick(rowIndex, 'Modify')"
                    v-if="row.code != 'admin'"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="handleClick(rowIndex, 'Detail')"
                    >查看</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="handleClick(rowIndex, 'Delete')"
                    v-if="row.code != 'admin'"
                    >删除</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="row.state == 0"
                    @click="handleClick(rowIndex, 'approve')"
                    >启用</el-button
                  >
                  <el-button
                    v-if="false"
                    type="text"
                    size="small"
                    v-show="row.state == 0"
                    @click="handleClick(rowIndex, 'refuse')"
                    >拒绝</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-show="row.state == 1 && isAdmin"
                    @click="passworedialogShow(row)"
                  >
                    修改密码</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="categorydialogShow(row)"
                    v-if="row.code != 'admin'"
                  >
                    修改课程分类</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="handleClick(rowIndex, 'DataPermission')"
                    v-if="row.code != 'admin' && getBtnQx('DataPermission')"
                  >
                    设置数据权限</el-button
                  >
                  <!-- <el-popconfirm
                    title="是否要删除?"
                    @confirm="handleClick(rowIndex, 'Delete')"
                  >
                    <template #reference>
                      <el-button size="small" type="text">删除</el-button>
                    </template>
                  </el-popconfirm> -->
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>

          <div class="pagination">
            <vxe-pager
              perfect
              size="mini"
              :current-page="PageQuery.pageindex"
              :page-size="PageQuery.PageSize"
              :page-sizes="[20, 50, 100, 500]"
              :total="total"
              :pager-count="5"
              :layouts="[
                'PrevJump',
                'PrevPage',
                'JumpNumber',
                'NextPage',
                'NextJump',
                'FullJump',
                'Sizes',
                'Total',
              ]"
              @page-change="handlePageChange"
            >
              <!-- <template #left>
                      <span class="page-left">
                          <span>已选中 {{ checkendSum }}</span>
                          <span class="clear" @click.prevent="$refs.multipleTable.clearCheckboxRow()">清空</span>
                      </span>
                  </template> -->
            </vxe-pager>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <UserEdit
        ref="UserEdit"
        v-model:dialogVisible="dialogVisible"
        @close-dialog="closeDialog"
        @handle-cancel="handleCancel"
        @handle-confirm="handleConfirm"
      ></UserEdit>
      <excel
        ref="industrialUnitExcel"
        :importurl="importurl"
        fileName="用户列表.xlsx"
        controlName="user"
        :dialogVisible="UpLoaddialogVisible"
        @close-dialog="closeUpDialog"
        @error="error"
        @success="success"
      ></excel>
      <password
        :dialogVisible="passworedialogVisible"
        @password-submitForm="Operation"
        @password-close="passwordclose"
      ></password>
      <category
        v-if="categorydialogVisible"
        :dialogVisible="categorydialogVisible"
        @category-submitForm="changeCategory"
        @category-close="categoryclose"
        :formData="categoryData"
      ></category>
    </div>
    <el-dialog
      v-if="visible"
      v-model="visible"
      title="选择城市"
      width="760px"
      append-to-body
      :close-on-click-modal="false"
      @close="onDeselect"
    >
      <div class="city-total">共选择{{ currentChoseNumber }}个城市</div>
      <div class="citycontent">
        <div class="col-list">
          <div
            class="list-item"
            :class="{'active': provinceId === item.id}"
            v-for="(item, index) in provinceList"
            @click="loadCity(item)"
            :key="item.id"
          >
            <span @click.stop>
              <el-checkbox
                v-model="item.isChecked"
                :indeterminate="item.indeterminate"
                :disabled="item.disabled"
                @change="handleChange('province', item, index)"
                >{{ item.areaName }}</el-checkbox
              >
            </span>
            <img src="@/assets/images/icon-left.png" />
          </div>
        </div>
        <div class="col-list" v-loading="loadingCity">
          <div
            class="list-item"
            v-for="item in cityList"
            :key="item.id"
          >
            <div class="label-box">
              <el-checkbox
                v-model="item.isChecked"
                :disabled="item.disabled"
                @change="handleChange('city', item)"
                >{{ item.areaName }}</el-checkbox
              >
            </div>
          </div>
        </div>
      </div>

      <template v-slot:footer>
        <div class="dialog-footer">
          <el-button @click="onDeselect"> 取消 </el-button>
          <el-button type="primary" @click="confirmSelect"> 确定 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Search, Delete } from "@element-plus/icons";
import { UserList } from "@/assets/apiData/Company/UserList";
import {
  GetDataUserListByPageQuery,
  DeleteUser,
  ModifyStatus,
  UpdataUserPossword,
  ExportUserInfo,
  EditUserCategory,
  GetUserDataPermissions,
  SaveUserDataPermissions
} from "@api/Company/ApiUser";
import { apiDefRegion } from "@api/dministrativeDivisions";

// import XEUtils from "xe-utils";
import UserEdit from "@comp/Company/UserEdit.vue";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
import { ElMessageBox } from "element-plus";
import { dateFormat } from "@/util/utils.js";
import password from "@comp/UserInfo/Password.vue";
import category from "@comp/UserInfo/Category.vue";

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          userName: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      dialogVisible: false,
      UpLoaddialogVisible: false,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,
      Industry: {
        CodeID: "",
        Name: "",
      },
      UserList: [],
      DataList: [],
      url: "",
      importurl: "/api/IndustrialUnit/ImportExcel?tabname=Industry",
      passworedialogVisible: false,
      currentrow: null,
      isAdmin: false,
      categorydialogVisible: false,
      categoryData: null,
      loading: false,
      visible: false,
      provinceList: [],
      cityList: [],
      provinceId: "",
      cityId: "",
      loadingCity: false,
      currentChoseNumber: 0,
      userAreaList: [],
      userId: 0,
    };
  },
  components: {
    UserEdit,
    excel,
    Search,
    password,
    category,
  },
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  mounted() {
    this.isAdmin = sessionStorage.getItem("UserID").toUpperCase() == "ADMIN";
  },
  methods: {
    getBtnQx(name) {
      let hasPermission = true;
      if(this.isAdmin) return hasPermission;
      let permissions = [];
      let pathName = this.$router.currentRoute.value.meta.breadcrumb.pathName
      if(sessionStorage.getItem("userPermissions")) {
        permissions = JSON.parse(sessionStorage.getItem("userPermissions"));
      }
      hasPermission = permissions.includes(pathName+name);
      return hasPermission
    },
    Operation(val, password) {
      //更新密码
      UpdataUserPossword({ userCode: this.currentrow.code, newPwd: password })
        .then((res) => {
          if (res) {
            //刷新
            this.GetData();
            this.$message.success("密码更新成功");
            this.passwordclose();
          } else this.$message.error("密码更新失败");
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
    passworedialogShow(row) {
      this.currentrow = row;
      this.passworedialogVisible = true;
    },
    passwordclose() {
      this.passworedialogVisible = false;
    },
    changeCategory(courseCategory) {
      const params = courseCategory.map((item) => {
        return {
          userId: this.categoryData.id,
          courseCategory: item,
        };
      });
      //更新课程分类
      EditUserCategory(params)
        .then((res) => {
          if (res) {
            //刷新
            this.GetData();
            this.$message.success("课程分类更新成功");
            this.categoryclose();
          } else this.$message.error("课程分类更新失败");
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
    categorydialogShow(row) {
      this.categoryData = row;
      this.categorydialogVisible = true;
    },
    categoryclose() {
      this.categorydialogVisible = false;
    },
    error() {},
    success() {
      this.GetData();
    },
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
    },
    importExcel() {
      this.UpLoaddialogVisible = true;
    },
    exportExcel() {
      const v = this;
      v.loading = true;
      GetDataUserListByPageQuery({
        ...v.PageQuery,
        ...{
          PageSize: v.total,
        },
      }).then(function (res) {
        v.loading = false;
        require.ensure([], () => {
          const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径
          const tHeader = [
            ...Enumerable.from(v.UserList)
              .where((item) => {
                return item.isExport
              })
              .select((item) => {
                return item.label;
              })
              .toArray(),
          ]; // 标题
          const filterVal = [
            ...Enumerable.from(v.UserList)
              .where((item) => {
                return item.isExport
              })
              .select((item) => {
                return item.prop;
              })
              .toArray(),
          ]; // 导出的字段名
          const list = res.entities;
          const data = v.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, `用户管理`);
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => {
        return filterVal.map((j) => {
          let cellValue = v[j];
          switch(j) {
            case "creationTime":
              cellValue = dateFormat("YYYY-mm-dd HH:MM:SS", cellValue);
              break;
            case "state":
              cellValue =
                cellValue == "0" ? "待审核" : cellValue == "1" ? "启用" : "禁用";
              break;
            case "type":
              const typeStrList = ["平台新增", "小程序注册", "平台导入"];
              cellValue = typeStrList[cellValue];
              break;
          }
          return cellValue;
        })
      });
    },
    handleClick(index, type) {
      console.log(index, type);

      this.UserEdit(index, type);
    },
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS", cellValue);
          break;
        case "checkbox":
          // cellValue = cellValue == "1" ? "是" : "否";
          cellValue = cellValue == "1" ? "启用" : "停用";
          break;
        case "status":
          cellValue =
            cellValue == "0" ? "待审核" : cellValue == "1" ? "启用" : "禁用";
          break;
        case "registerType":
          const typeStrList = ["平台新增", "小程序注册", "平台导入"];
          cellValue = typeStrList[cellValue];
          break;
      }
      return cellValue;
    },
    UserEdit(index, type) {
      var _this = this;
      if (type == "Delete") {
        ElMessageBox.confirm(`是否要删除?`, "提示", {
          cancelButtonClass: "cancelstyle",
          confirmButtonClass: "confirmstyle",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
        })
          .then(() => {
            DeleteUser(this.DataList[index].id).then(function (data) {
              if (data) {
                _this.$message.success("删除成功");
                _this.PageQuery.pageindex = 1;
                _this.GetData();
              }
            });
          })
          .catch(() => {
            return;
          });
      } else if (type == "approve") {
        // 同意
        ModifyStatus(_this.DataList[index].id, 1).then(function (data) {
          if (data) {
            _this.$message.success("操作成功");
            _this.DataList[index].state = "1";
          }
        });
      } else if (type == "refuse") {
        // 拒绝
        ModifyStatus(_this.DataList[index].id, 2).then(function (data) {
          if (data) {
            _this.$message.success("操作成功");
            _this.DataList[index].state = "2";
          }
        });
      } else if (type == "DataPermission") {
        // 设置数据权限
        _this.handleCity(this.DataList[index])
      } else {
        this.dialogVisible = true;
        var id = 0;
        if (type != "Add") id = _this.DataList[index].id;
        this.$refs.UserEdit.loadDataById(id, type);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    add() {
      this.UserEdit(-1, "Add");
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },

    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      // this.GetData();
    },
    SearchDataInfo() {},
    GetData() {
      const _this = this;
      this.SearchDataInfo();
      try {
        GetDataUserListByPageQuery(JSON.stringify(this.PageQuery)).then(
          function (data) {
            _this.DataList = data.entities;
            _this.total = data.totalCount;
          }
        );
      } catch (e) {
        console.log(e);
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    async handleCity(row) {
      this.visible = true;
      // 获取用户已设置的数据权限
      this.userId = row.id;
      this.userAreaList = await GetUserDataPermissions(row.id);
      let areaList = [];
      this.userAreaList.forEach(area=> {
        area.areaList.forEach(crt=> {
          areaList.push({
            isChecked: area.isAll !== 0,
            indeterminate: area.isAll === 0,
            id: crt.cityId,
            parent_id: crt.provinceId
          })
        })
      })
      if(areaList.length) {
        this.provinceId = areaList[0].parent_id
        let provinceCode = this.provinceList.find(item => item.id == this.provinceId).code;
        this.loadingCity = true
        let { entities } = await apiDefRegion(3);
        let data = entities.filter(item=> item.parentCode === provinceCode);
        this.cityList = data;
        this.loadingCity = false
        this.provinceList.forEach((e) => {
          let current = areaList.find(item=>item.parent_id === e.id)
          let choseCity = areaList.filter(item=>item.parent_id === e.id)
          e.isChecked = current ? current.isChecked : false;
          e.indeterminate = current ? current.indeterminate : false;
          e.choseCitys = choseCity.map(item=> {
            return {
              isChecked: true,
              id: item.id,
              parent_id: item.parent_id
            }
          })
        });
        let choseCity = areaList.filter(item=>item.parent_id === this.provinceId)
        this.cityList.forEach((e) => {
          e.isChecked = choseCity.some(item=>item.id === e.id);
        });
      } else {
        // 还未添加城市的包邮规则
        this.provinceList.forEach((e) => {
          e.isChecked = false;
          e.indeterminate = false;
        });
        this.cityList.forEach((e) => {
          e.isChecked = false;
        });
      }
      this.currentChoseNumber = this.provinceList.reduce((prev, cur)=> {
        return prev + cur.choseCitys.length
      }, 0)
    },
    async loadCity(row) {
      if(this.cityList.length === 0) {  // 第一次打开
        this.provinceId = row.id
        let provinceCode = row.code
        this.loadingCity = true
        let { entities } = await apiDefRegion(3);
        let data = entities.filter(item=> item.parentCode === provinceCode);
        data.forEach(item=> {
          item['isChecked'] = false
        })
        this.cityList = data;
        this.loadingCity = false
      } else {
        if(this.provinceId !== row.id) {
          this.provinceId = row.id
          let provinceCode = row.code
          this.loadingCity = true
          let { entities } = await apiDefRegion(3);
          let data = entities.filter(item=> item.parentCode === provinceCode);
          data.forEach(item=> {
            item['isChecked'] = row.choseCitys.some(city=>city.id === item.id)
          })
          this.cityList = data;
          this.loadingCity = false
        }
      }
    },
    async handleChange(type, item, index) {
      if(type === 'province') {
        if(this.cityList.length) {
          if(this.provinceId === item.id) {
            this.provinceList[index].indeterminate = false
            this.cityList.forEach(row=> {
              row.isChecked = item.isChecked
            })
            if(item.isChecked) {
              this.provinceList[index].choseCitys = [...this.cityList]
            } else {
              this.provinceList[index].choseCitys = []
            }
            this.currentChoseNumber = this.provinceList.reduce((prev, cur)=> {
              return prev + cur.choseCitys.length
            }, 0)
          } else {
            this.provinceId = item.id;
            this.getCityList(index);
          }
        } else {
          this.provinceId = item.id;
          let provinceCode = item.code;
          this.loadingCity = true
          let { entities } = await apiDefRegion(3);
          let data = entities.filter(item=> item.parentCode === provinceCode);
          data.forEach(item=>item['isChecked'] = true)
          this.cityList = data;
          this.loadingCity = false
          this.provinceList[index].choseCitys = [...this.cityList]
          this.currentChoseNumber = this.provinceList.reduce((prev, cur)=> {
            return prev + cur.choseCitys.length
          }, 0)
        }
      } else {
        const currentProvinceKey = this.provinceList.findIndex(province=>province.code === item.parentCode)
        if(item.isChecked) {
          this.provinceList[currentProvinceKey].choseCitys.push(item)
          this.provinceList[currentProvinceKey].isChecked = this.provinceList[currentProvinceKey].choseCitys.length === this.cityList.length
          this.provinceList[currentProvinceKey].indeterminate = this.provinceList[currentProvinceKey].choseCitys.length !== this.cityList.length
          this.currentChoseNumber += 1
        } else {
          const currentCityKey = this.provinceList[currentProvinceKey].choseCitys.findIndex(city=>city.id === item.id)
          this.provinceList[currentProvinceKey].choseCitys.splice(currentCityKey, 1)
          this.provinceList[currentProvinceKey].isChecked = false
          this.provinceList[currentProvinceKey].indeterminate = this.provinceList[currentProvinceKey].choseCitys.length > 0
          this.currentChoseNumber -= 1
        }
      }
    },
    // 获取省份列表
    getProvinceList() {
      if(this.provinceList.length === 0) {
        apiDefRegion(2).then(res=> {
          this.provinceList = res.entities.map(item=> {
            return {
              ...item,
              isChecked: false,
              indeterminate: false,
              disabled: false,
              choseCitys: []
            }
          })
        })
      }
    },
    async getCityList(index) {
      this.loadingCity = true
      let { entities } = await apiDefRegion(3);
      let provinceCode = this.provinceList.find(item => item.id == this.provinceId).code;
      let data = entities.filter(item=> item.parentCode === provinceCode);
      if(this.provinceList[index].choseCitys.length === data.length) {
        data.forEach(item=>item['isChecked'] = false)
        this.provinceList[index].choseCitys = []
      } else {
        data.forEach(item=>item['isChecked'] = true)
        this.provinceList[index].indeterminate = false
        this.provinceList[index].choseCitys = [...data]
      }
      this.cityList = data;
      this.loadingCity = false
      this.currentChoseNumber = this.provinceList.reduce((prev, cur)=> {
        return prev + cur.choseCitys.length
      }, 0)
    },
    // 取消选择城市
    onDeselect() {
      this.provinceId = ''
      this.cityList = []
      this.provinceList.forEach(item=> {
        item.isChecked = false
        item.indeterminate = false
        item.choseCitys = []
      })
      this.visible = false
      this.userAreaList = [];
      this.userId = 0;
    },
    // 选择城市确定
    async confirmSelect() {
      let checkedCityList = []
      this.provinceList.filter(item=>item.choseCitys.length > 0).forEach(item=> {
        item.choseCitys.forEach(chose=>{
          if(chose.isChecked) {
            checkedCityList.push({
              cityId: chose.id,
              provinceId: item.id
            })
          }
        })
      })
      this.userAreaList = checkedCityList
      // 保存
      await SaveUserDataPermissions(this.userAreaList,this.userId);
      this.onDeselect()
    },
  },
  created() {
    this.UserList = UserList;
    this.GetData();
    this.getProvinceList()
    //console.log(UserList);
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
.city-total {
  padding: 12px 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
}
.citycontent {
  width: 100%;
  display: flex;
  border: 1px solid #e5e5e5;
  .col-list {
    width: 300px;
    height: 400px;
    overflow: auto;
    border-right: 1px solid #e5e5e5;
    padding: 8px 15px;
    display: flex;
    flex-direction: column;
  }
  .list-item {
    width: 100%;
    height: 36px;
    line-height: 36px;
    padding: 0 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .label-box {
      width: 100%;
      :deep(.el-checkbox) {
        width: 100%;
      }
    }
    img {
      width: 20px;
      height: 20px;
      padding-right: 5px;
    }
  }
  .list-item.active {
    background: #f5f7fa;
  }
  .list-item:last-child {
    margin-bottom: 0;
  }
  .col-list:last-child {
    border: none;
  }
  .col-list::-webkit-scrollbar {
    height: 5px;
    width: 3px;
  }
}
</style>
<style scoped>
</style>
